import { negate } from "lodash";
import { doesEntryNotMatchGiven } from "app/pages/sales-intelligence/sub-modules/advanced-search/helpers/technologies";
import type { TechnologiesConditionEntry } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import type TechnologySignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalFilters";
import type TechnologySignalTechnologiesFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFilters";
import { useMemo } from "react";
import { buildEntriesFromFilter } from "app/pages/sales-intelligence/sub-modules/signals/utils/technologies/buildEntriesFromFilter";
import { buildFilterFromEntries } from "../utils/buildFilterFromEntries";

const useCompoundTechnologiesFilterState = (
    selectedValue: Partial<TechnologySignalTechnologiesFilters>,
    onValueChange: (filters: Partial<TechnologySignalFilters>) => void,
) => {
    const selectedEntries = useMemo(() => buildEntriesFromFilter(selectedValue), [selectedValue]);

    const getSelectedEntries = (entry: Readonly<TechnologiesConditionEntry>) => {
        const isSelected = selectedEntries.some(negate(doesEntryNotMatchGiven(entry)));

        if (isSelected) {
            return selectedEntries.filter(doesEntryNotMatchGiven(entry));
        }

        return [...selectedEntries, entry];
    };

    const handleItemClick = (entry: Readonly<TechnologiesConditionEntry>) => {
        const filterValue = buildFilterFromEntries(getSelectedEntries(entry));

        onValueChange(filterValue);
    };

    return { selectedEntries, handleItemClick };
};

export default useCompoundTechnologiesFilterState;
